var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "app-container" },
    [
      _c("BoxWrap", { attrs: { title: _vm.$t("lookup.BoxWrap.manage") } }, [
        _c(
          "div",
          { attrs: { slot: "header-right" }, slot: "header-right" },
          [
            _c(
              "el-button",
              {
                directives: [
                  {
                    name: "FPermission",
                    rawName: "v-FPermission",
                    value: { pageName: _vm.pageName, list: ["LIST"] },
                    expression: "{pageName, list: ['LIST']}",
                  },
                ],
                attrs: {
                  type: "primary",
                  size: "small",
                  icon: "el-icon-search",
                },
                on: { click: _vm.searchData },
              },
              [_vm._v(_vm._s(_vm.$t("common.search")))]
            ),
            _vm._v(" "),
            _c(
              "el-button",
              {
                directives: [
                  {
                    name: "FPermission",
                    rawName: "v-FPermission",
                    value: { pageName: _vm.pageName, list: ["ADD_EDIT"] },
                    expression: "{pageName, list: ['ADD_EDIT']}",
                  },
                ],
                attrs: { type: "primary", size: "small", icon: "el-icon-plus" },
                on: { click: _vm.create },
              },
              [_vm._v(_vm._s(_vm.$t("common.create")))]
            ),
          ],
          1
        ),
        _vm._v(" "),
        _c(
          "div",
          {
            directives: [
              {
                name: "FPermission",
                rawName: "v-FPermission",
                value: { pageName: _vm.pageName, list: ["LIST"] },
                expression: "{pageName, list: ['LIST']}",
              },
            ],
            staticClass: "action-container",
          },
          [
            _c(
              "el-form",
              { attrs: { size: "small", inline: "", "label-position": "top" } },
              [
                _c(
                  "el-row",
                  {
                    staticClass: "row-bg",
                    attrs: { type: "flex", justify: "space-between" },
                  },
                  [
                    _c(
                      "el-col",
                      { attrs: { span: 7 } },
                      [
                        _c(
                          "el-form-item",
                          { attrs: { label: _vm.$t("lookup.input.typeName") } },
                          [
                            _c("el-input", {
                              attrs: {
                                placeholder: _vm.$t(
                                  "lookup.input.typeNameHolder"
                                ),
                                clearable: "",
                              },
                              model: {
                                value: _vm.searchVal.typeName,
                                callback: function ($$v) {
                                  _vm.$set(_vm.searchVal, "typeName", $$v)
                                },
                                expression: "searchVal.typeName",
                              },
                            }),
                          ],
                          1
                        ),
                      ],
                      1
                    ),
                    _vm._v(" "),
                    _c(
                      "el-col",
                      { attrs: { span: 7 } },
                      [
                        _c(
                          "el-form-item",
                          { attrs: { label: _vm.$t("lookup.input.typeCode") } },
                          [
                            _c("el-input", {
                              attrs: {
                                placeholder: _vm.$t(
                                  "lookup.input.typeCodeHolder"
                                ),
                                clearable: "",
                              },
                              model: {
                                value: _vm.searchVal.typeCode,
                                callback: function ($$v) {
                                  _vm.$set(_vm.searchVal, "typeCode", $$v)
                                },
                                expression: "searchVal.typeCode",
                              },
                            }),
                          ],
                          1
                        ),
                      ],
                      1
                    ),
                    _vm._v(" "),
                    _c("el-col", { attrs: { span: 7 } }),
                  ],
                  1
                ),
              ],
              1
            ),
          ],
          1
        ),
      ]),
      _vm._v(" "),
      _c(
        "BoxWrap",
        {
          staticClass: "main-table-container",
          attrs: { title: _vm.$t("lookup.BoxWrap.list") },
        },
        [
          _c(
            "el-table",
            {
              directives: [
                {
                  name: "loading",
                  rawName: "v-loading",
                  value: _vm.listLoading,
                  expression: "listLoading",
                },
              ],
              staticStyle: { width: "100%" },
              attrs: {
                data: _vm.list,
                stripe: "",
                "highlight-current-row": "",
                "tooltip-effect": "dark",
              },
            },
            [
              _c("el-table-column", {
                attrs: {
                  prop: "sn",
                  type: "index",
                  index: _vm.tableIndex,
                  label: _vm.$t("lookup.table.sequence"),
                  width: "80",
                  align: "center",
                  "show-overflow-tooltip": "",
                },
              }),
              _vm._v(" "),
              _c("el-table-column", {
                attrs: {
                  prop: "typeName",
                  label: _vm.$t("lookup.table.typeName"),
                  "min-width": "200",
                  align: "left",
                  "show-overflow-tooltip": "",
                },
              }),
              _vm._v(" "),
              _c("el-table-column", {
                attrs: {
                  prop: "typeCode",
                  label: _vm.$t("lookup.table.typeCode"),
                  "min-width": "200",
                  align: "left",
                  "show-overflow-tooltip": "",
                },
              }),
              _vm._v(" "),
              _c("el-table-column", {
                attrs: {
                  prop: "remark",
                  label: _vm.$t("lookup.table.remark"),
                  "min-width": "200",
                  align: "left",
                  "show-overflow-tooltip": "",
                },
              }),
              _vm._v(" "),
              _c("el-table-column", {
                attrs: {
                  label: _vm.$t("lookup.table.action"),
                  fixed: "right",
                  width: "140",
                  align: "center",
                },
                scopedSlots: _vm._u([
                  {
                    key: "default",
                    fn: function (scope) {
                      return [
                        _c("el-button", {
                          directives: [
                            {
                              name: "FPermission",
                              rawName: "v-FPermission",
                              value: {
                                pageName: _vm.pageName,
                                list: ["ADD_EDIT"],
                              },
                              expression: "{pageName, list: ['ADD_EDIT']}",
                            },
                          ],
                          staticClass: "t-square-btn t-green-btn",
                          attrs: {
                            type: "primary",
                            size: "mini",
                            icon: "el-icon-edit",
                            circle: "",
                          },
                          on: {
                            click: function ($event) {
                              return _vm.edit(scope.row)
                            },
                          },
                        }),
                        _vm._v(" "),
                        _c("el-button", {
                          directives: [
                            {
                              name: "FPermission",
                              rawName: "v-FPermission",
                              value: {
                                pageName: _vm.pageName,
                                list: ["DELETE"],
                              },
                              expression: "{pageName, list: ['DELETE']}",
                            },
                          ],
                          staticClass: "t-square-btn t-red-btn",
                          attrs: {
                            type: "danger",
                            size: "mini",
                            icon: "el-icon-delete",
                            circle: "",
                          },
                          on: {
                            click: function ($event) {
                              return _vm.deleteItem(scope.row)
                            },
                          },
                        }),
                        _vm._v(" "),
                        _c(
                          "el-dropdown",
                          { attrs: { trigger: "click", size: "medium" } },
                          [
                            _c("el-button", {
                              staticClass: "t-square-btn t-more-btn",
                              attrs: {
                                type: "danger",
                                size: "mini",
                                icon: "el-icon-more",
                                circle: "",
                              },
                            }),
                            _vm._v(" "),
                            _c(
                              "el-dropdown-menu",
                              { attrs: { slot: "dropdown" }, slot: "dropdown" },
                              [
                                _c(
                                  "el-dropdown-item",
                                  {
                                    nativeOn: {
                                      click: function ($event) {
                                        return _vm.view(scope.row)
                                      },
                                    },
                                  },
                                  [
                                    _vm._v(
                                      _vm._s(_vm.$t("lookup.dropdown.view"))
                                    ),
                                  ]
                                ),
                              ],
                              1
                            ),
                          ],
                          1
                        ),
                      ]
                    },
                  },
                ]),
              }),
            ],
            1
          ),
          _vm._v(" "),
          _c("pagination", {
            directives: [
              {
                name: "show",
                rawName: "v-show",
                value: _vm.total > 0,
                expression: "total>0",
              },
            ],
            attrs: { total: _vm.total, page: _vm.currPage, limit: _vm.limit },
            on: {
              "update:page": function ($event) {
                _vm.currPage = $event
              },
              "update:limit": function ($event) {
                _vm.limit = $event
              },
              pagination: _vm.fetchData,
            },
          }),
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "Model",
        {
          attrs: {
            width: "640px",
            form: _vm.form,
            "init-form": _vm.initForm,
            "is-show": _vm.isShowModel,
            "dialog-status": _vm.dialogStatus,
            "save-item": _vm.saveItem,
          },
          on: {
            "update:isShow": function ($event) {
              _vm.isShowModel = $event
            },
            "update:is-show": function ($event) {
              _vm.isShowModel = $event
            },
          },
        },
        [
          _c(
            "el-form",
            {
              ref: "dataForm",
              attrs: { model: _vm.form, rules: _vm.rules, size: "small" },
            },
            [
              _c(
                "el-form-item",
                {
                  attrs: {
                    prop: "typeName",
                    label: _vm.$t("lookup.form.typeName"),
                    "label-width": _vm.formLabelWidth,
                  },
                },
                [
                  _c("el-input", {
                    attrs: { autocomplete: "off" },
                    model: {
                      value: _vm.form.typeName,
                      callback: function ($$v) {
                        _vm.$set(_vm.form, "typeName", $$v)
                      },
                      expression: "form.typeName",
                    },
                  }),
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "el-form-item",
                {
                  attrs: {
                    prop: "typeCode",
                    label: _vm.$t("lookup.form.typeCode"),
                    "label-width": _vm.formLabelWidth,
                  },
                },
                [
                  _c("el-input", {
                    attrs: { autocomplete: "off" },
                    model: {
                      value: _vm.form.typeCode,
                      callback: function ($$v) {
                        _vm.$set(_vm.form, "typeCode", $$v)
                      },
                      expression: "form.typeCode",
                    },
                  }),
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "el-form-item",
                {
                  attrs: {
                    label: _vm.$t("lookup.form.remark"),
                    "label-width": _vm.formLabelWidth,
                  },
                },
                [
                  _c("el-input", {
                    attrs: { type: "textarea", rows: 4, autocomplete: "off" },
                    model: {
                      value: _vm.form.remark,
                      callback: function ($$v) {
                        _vm.$set(_vm.form, "remark", $$v)
                      },
                      expression: "form.remark",
                    },
                  }),
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "el-table",
                {
                  staticClass: "creat-lookup-table",
                  staticStyle: { width: "100%" },
                  attrs: { data: _vm.form.values },
                },
                [
                  _c(
                    "el-table-column",
                    {
                      attrs: {
                        label: _vm.$t("lookup.form.searchCode"),
                        align: "right",
                        "min-width": "210",
                      },
                      scopedSlots: _vm._u([
                        {
                          key: "default",
                          fn: function (scope) {
                            return [
                              _c(
                                "el-form-item",
                                {
                                  attrs: {
                                    prop:
                                      "values." + scope.$index + ".valueCode",
                                    rules: _vm.rules.valueCode,
                                  },
                                },
                                [
                                  _c("el-input", {
                                    attrs: { autocomplete: "off" },
                                    model: {
                                      value: scope.row.valueCode,
                                      callback: function ($$v) {
                                        _vm.$set(scope.row, "valueCode", $$v)
                                      },
                                      expression: "scope.row.valueCode",
                                    },
                                  }),
                                ],
                                1
                              ),
                            ]
                          },
                        },
                      ]),
                    },
                    [
                      _c(
                        "template",
                        { slot: "header" },
                        [
                          _c("el-button", {
                            staticStyle: { float: "left" },
                            attrs: {
                              type: "primary",
                              size: "mini",
                              icon: "el-icon-plus",
                              circle: "",
                            },
                            on: { click: _vm.addValue },
                          }),
                          _vm._v(" "),
                          _c("span", { staticClass: "cell-text" }, [
                            _vm._v(_vm._s(_vm.$t("lookup.form.searchCode"))),
                          ]),
                        ],
                        1
                      ),
                    ],
                    2
                  ),
                  _vm._v(" "),
                  _c("el-table-column", {
                    attrs: {
                      label: _vm.$t("lookup.form.searchName"),
                      align: "right",
                      "min-width": "210",
                    },
                    scopedSlots: _vm._u([
                      {
                        key: "default",
                        fn: function (scope) {
                          return [
                            _c(
                              "el-form-item",
                              {
                                attrs: {
                                  prop: "values." + scope.$index + ".valueName",
                                  rules: _vm.rules.valueName,
                                },
                              },
                              [
                                _c("el-input", {
                                  attrs: { autocomplete: "off" },
                                  model: {
                                    value: scope.row.valueName,
                                    callback: function ($$v) {
                                      _vm.$set(scope.row, "valueName", $$v)
                                    },
                                    expression: "scope.row.valueName",
                                  },
                                }),
                              ],
                              1
                            ),
                          ]
                        },
                      },
                    ]),
                  }),
                  _vm._v(" "),
                  _c("el-table-column", {
                    attrs: {
                      label: _vm.$t("common.enable"),
                      align: "center",
                      width: "80",
                    },
                    scopedSlots: _vm._u([
                      {
                        key: "default",
                        fn: function (scope) {
                          return [
                            _c("el-switch", {
                              model: {
                                value: scope.row.state,
                                callback: function ($$v) {
                                  _vm.$set(scope.row, "state", $$v)
                                },
                                expression: "scope.row.state",
                              },
                            }),
                          ]
                        },
                      },
                    ]),
                  }),
                  _vm._v(" "),
                  _c("el-table-column", {
                    attrs: {
                      label: _vm.$t("lookup.form.action"),
                      align: "center",
                      width: "60",
                    },
                    scopedSlots: _vm._u([
                      {
                        key: "default",
                        fn: function (scope) {
                          return [
                            _c("el-button", {
                              staticClass: "t-square-btn t-red-btn",
                              attrs: {
                                type: "danger",
                                size: "mini",
                                icon: "el-icon-delete",
                                circle: "",
                              },
                              on: {
                                click: function ($event) {
                                  return _vm.deleteValue(
                                    scope.$index,
                                    scope.row
                                  )
                                },
                              },
                            }),
                          ]
                        },
                      },
                    ]),
                  }),
                ],
                1
              ),
            ],
            1
          ),
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "Model",
        {
          attrs: {
            width: "860px",
            "is-show": _vm.isShowModelView,
            "dialog-status": _vm.dialogStatus,
            "is-only-confirm": true,
            "save-item": _vm.closeView,
          },
          on: {
            "update:isShow": function ($event) {
              _vm.isShowModelView = $event
            },
            "update:is-show": function ($event) {
              _vm.isShowModelView = $event
            },
          },
        },
        [
          _c(
            "div",
            { staticClass: "main-table-container" },
            [
              _c(
                "el-table",
                {
                  staticStyle: { width: "100%" },
                  attrs: {
                    data: _vm.form.values,
                    stripe: "",
                    "highlight-current-row": "",
                    "tooltip-effect": "dark",
                  },
                },
                [
                  _c("el-table-column", {
                    attrs: {
                      prop: "sn",
                      type: "index",
                      index: _vm.tableIndex,
                      label: _vm.$t("lookup.table.sequence"),
                      "min-width": "60",
                      align: "center",
                      "show-overflow-tooltip": "",
                    },
                  }),
                  _vm._v(" "),
                  _c("el-table-column", {
                    attrs: {
                      prop: "valueCode",
                      label: _vm.$t("lookup.table.valueCode"),
                      "min-width": "240",
                      align: "left",
                      "show-overflow-tooltip": "",
                    },
                  }),
                  _vm._v(" "),
                  _c("el-table-column", {
                    attrs: {
                      prop: "valueName",
                      label: _vm.$t("lookup.table.valueName"),
                      "min-width": "240",
                      align: "left",
                      "show-overflow-tooltip": "",
                    },
                  }),
                  _vm._v(" "),
                  _c("el-table-column", {
                    attrs: {
                      label: _vm.$t("lookup.table.state"),
                      "min-width": "60",
                      align: "center",
                    },
                    scopedSlots: _vm._u([
                      {
                        key: "default",
                        fn: function (scope) {
                          return [
                            _c(
                              "el-tag",
                              {
                                attrs: {
                                  size: "small",
                                  type: scope.row.state ? "success" : "info",
                                },
                              },
                              [
                                _vm._v(
                                  _vm._s(
                                    _vm.$t(
                                      "common." +
                                        (scope.row.state
                                          ? "ENABLE"
                                          : "DISABLED")
                                    )
                                  )
                                ),
                              ]
                            ),
                          ]
                        },
                      },
                    ]),
                  }),
                ],
                1
              ),
            ],
            1
          ),
        ]
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }